import { Stepper, Step, withStyles, StepLabel } from "@material-ui/core";
import React from "react";

import { useTranslations } from "adapters/i18n";

const PlanningRegisterSteps = ({
  classes,
  stepsContent = [],
  stepsActionButons = [],
  activeStep = 0,
}) => {
  const { t } = useTranslations();
  const STEP_LABELS = [
    t("planning:steps.planning"),
    t("planning:steps.ingredient-cost"),
    t("planning:steps.review"),
  ];

  const contentToRender = stepsContent[activeStep] || (() => <> </>);
  const actionButtonToRender = stepsActionButons[activeStep] || (() => <> </>);

  return (
    <div className={classes.stepContainer}>
      <Stepper
        className={classes.stepper}
        activeStep={activeStep}
        nonLinear={true}
      >
        {STEP_LABELS.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                classes: {
                  root: classes.stepIconRoot,
                  active: classes.stepIconActive,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {contentToRender()}
      {actionButtonToRender()}
    </div>
  );
};

const styles = () => ({
  stepIconActive: {
    color: "#1976D2 !important",
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
});

export default withStyles(styles)(PlanningRegisterSteps);
